import { z } from 'zod';

export const updateParticipantDispensariesResDto = z.object({
  message: z.string(),
  data: z.object({
    participantID: z.string(),
    dispensaries: z.array(z.string()),
  }),
});
export type UpdateParticipantDispensariesResDto = z.infer<
  typeof updateParticipantDispensariesResDto
>;
